import axios from "axios";

async function getDataProjects() {
  const apiURL = "https://api-ekata.ekata.id/api/projects";

  return await axios
    .get(apiURL)
    .then((response) => {
      console.log("Projects : ", response.data.data);
      return response.data.data;
    })
    .catch((error) => {
      console.log(error);
      return [
        {
          client_id: 1,
          title: "NOT FOUND",
          project_url: "/",
        },
      ];
    });
}

async function getDataProjectsbyId(id) {
  const apiURL = `https://api-ekata.ekata.id/api/projects/${id}`;

  return await axios
    .get(apiURL)
    .then((response) => {
      console.log("Projects : ", response.data.data);
      return response.data.data;
    })
    .catch((error) => {
      console.log(error);
      return [
        {
          client_id: 1,
          title: "NOT FOUND",
          project_url: "/",
        },
      ];
    });
}


export { getDataProjects, getDataProjectsbyId };
